var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-fill centerArea"},[_c('DefaultToolbar'),_c('CanvasComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }